import { Button, Typography, WarningStatusIcon } from '@pebl/ui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationComponentProps } from '@/types/translation';

type SiteBadlyConfiguredProps = {} & Partial<TranslationComponentProps>;

/**
 * If the site is loaded in an unrecoverable state (e.g. configuration.js
 * failed to fetch OR is invalid I.E. missing apiUrl) then we show this
 * error state to the user.
 */
export function SiteBadlyConfigured({ t }: SiteBadlyConfiguredProps) {
  /**
   * This is NOT the pattern we normally use for handling translations,
   * however due to how this component gets used in the routing setup
   * and my desire to not completely break/refactor all of that code,
   * this has the `useTranslation` within the component (as a fallback)
   * rather than ONLY accepting it in as a prop.
   */
  const { t: internalT } = useTranslation();
  const translate = t ?? internalT;

  const handleRefresh = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <div className="qng-error-site-config max-w-full pt-12 text-center">
      <WarningStatusIcon className="qng-error-site-config-icon mx-auto size-16" />
      <Typography
        variant="h3"
        className="qng-error-site-config-header overflow-hidden text-ellipsis"
      >
        {translate('site_badly_configured.header')}
      </Typography>
      <Typography
        variant="h4"
        className="qng-error-site-config-description mt-8 overflow-hidden text-ellipsis"
      >
        {translate('site_badly_configured.description')}
      </Typography>
      <Button
        className="qng-error-site-config-button mt-4"
        onClick={handleRefresh}
      >
        {translate('site_badly_configured.button')}
      </Button>
    </div>
  );
}
